import { Link } from "react-router-dom"

export const DEFAULT_AUTH_ERROR = 'Something went wrong. Please try again or contact support if the problem continues.'

export function withDefaultAuthErrors (errors, fallbackMessage = DEFAULT_AUTH_ERROR) {
  if (errors?.length) {
    return errors
  }
  if (!fallbackMessage) {
    return errors
  }
  return [{ message: fallbackMessage, param: null }]
}

export default function FormErrors (props) {
  const sourceErrors = withDefaultAuthErrors(props.errors, props.fallbackMessage)
  if (!sourceErrors || !sourceErrors.length) {
    return null
  }
  const errors = props.param === '*' ? sourceErrors : sourceErrors.filter(error => (props.param ? error.param === props.param : error.param == null))
  if (!errors.length) {
    return null
  }
  return <ul className={"authErrors"} style={{ color: 'darkred', fontSize:'15px' }}>{errors.map((e, i) => {
    if (e.message === 'This field is required.') {
      return   <li key={i}><span>The field </span> <em>{e.param}</em> <span> is required.</span></li>
    } else if (e.code === 'unverified_email') {
      return   <li key={i}>{e.message} Resend  <Link style={{color:'darkred', textDecoration:'underline'}} to='/account/email'>verification email here</Link></li>
    } else {
      return   <li key={i}>{e.message}</li>
    }

  })}</ul>
}
